import Skeleton from '@mui/material/Skeleton';
import { isNone, openWindow } from 'common/utils/utils';
import { KebabMenu } from 'common/components/kebabMenu';

import Hint from 'features/templateBuilder/TemplateSection/HintIcon';
import { useUserDetailsByName } from 'remote-state/ticketServiceHooks';
import { LOADING_DISPLAY_NAME } from '../../consts';
import { StyledFieldName, StyledField, FieldNameText } from './styledFieldName';
import { StyledAsterisk } from './styledAsterisk';
import useTexts from '../useTexts';
import { handleURL } from './utils';

export default function FieldName(props) {
  const { className, name, required, hintText, hasMoreDetails, url, urlParams, fieldValue, isTemplatePage } = props;
  const { moreDetails } = useTexts();

  const urlParamsKeys = urlParams && Object.keys(urlParams);
  const isUserField = urlParamsKeys && (urlParamsKeys.includes('userName') || urlParamsKeys.includes('userType'));

  const { data: userDetails } = useUserDetailsByName(isUserField ? fieldValue?.userName || fieldValue : undefined);

  const handleKebabMenuAction = (actionName) => {
    switch (actionName) {
      case 'openWindowLink':
        openWindow(handleURL({ url, urlParams, userDetails, fieldValue }));
        break;
      default:
        break;
    }
  };

  return (
    <StyledField isTemplatePage={isTemplatePage} className="field-name-title">
      <StyledFieldName className={className}>
        {name === LOADING_DISPLAY_NAME ? (
          <Skeleton variant='rounded' width={120} height={16} style={{ marginBottom: '4px' }}/>
        ) : (
          <FieldNameText data-cy="field-name-text">{name}</FieldNameText>
        )}
        {required && <StyledAsterisk>&nbsp;*</StyledAsterisk>}
        {hintText && <Hint hintText={hintText} />}
      </StyledFieldName>
      {hasMoreDetails && !isNone(fieldValue) && (
        <KebabMenu
          isVisible={Boolean(fieldValue) || fieldValue === 0}
          handleKebabMenuAction={handleKebabMenuAction}
          actionList={[{ name: 'openWindowLink', defaultCaption: moreDetails }]}
        />
      )}
    </StyledField>
  );
}
